import ReactDom from 'react-dom/server';
import provider from "@gqlapp/qrcode/nodevn";
import getStyle from "./utils/Style";
import qrtag from './utils';

export function getSvg({ text: data_text, input }: any)  {
	
	let { frame, selectedIndex } = input || {}
	
	
	let style = getStyle(frame || {})
	
	let isCircle = style === 'circle';
	// debug("############################### 0");
	if(selectedIndex >= Object.keys(provider).length || !selectedIndex){
		selectedIndex = 0;
	}
	
	// debug("############################### 1");
	
	let Base = provider[selectedIndex];
	// debug("############################### 2");
	data_text = qrtag(data_text);
	// debug("############################### 3");
	
	return (new Base({ ...input, data_text, frame: { ...frame, style }, isCircle }, null)).toSvg();
}

export default async function (props: any){
	const qrcode: any = getSvg(props)
	return ReactDom.renderToString(qrcode)
};
